import * as yup from "yup";
import { useFormik } from "formik";

export const useEpcsModalForm = (submitter, initialFormValues) => {
  const schema = yup.object().shape({
    dea: yup.string().required(),
    licenseNumber: yup.string().required(),
    npi: yup.string().required(),
  });

  const { values, setFieldValue, handleSubmit, errors } = useFormik({
    validationSchema: schema,
    initialValues: initialFormValues,
    onSubmit: (values) =>
      submitter({
        dea: values.dea,
        license_number: values.licenseNumber,
        npi: values.npi,
      }),
  });

  const handleInputChange = (e) => {
    setFieldValue(e.target.name, e.target.value);
  };

  return {
    values,
    handleInputChange,
    handleSubmit,
    errors,
  };
};
